export default __webpack_public_path__ + "static/media/riverislandapp02.a92859c8.mp4";